export const USAGE_IDLE_MS = 5 * 60 * 1000;

export function createActiveClock(now, visible = true) {
  let sampledAt = now, interactedAt = now, foreground = visible, pending = 0;
  const sample = time => {
    const elapsed = time - sampledAt;
    if (foreground && elapsed > 0 && elapsed <= 60000) {
      pending += Math.max(0, Math.min(time, interactedAt + USAGE_IDLE_MS) - sampledAt);
    }
    sampledAt = time;
  };
  return {
    sample,
    interact(time) { sample(time); interactedAt = time; },
    visibility(time, value) { sample(time); foreground = value; },
    take(time) { sample(time); const result = Math.min(45000, Math.floor(pending)); pending = 0; return result; },
  };
}

export function usageDuration(ms) {
  if (ms == null) return "Not recorded";
  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  return minutes < 60 ? `${minutes}m ${seconds % 60}s` : `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}

export function portalAccountIssue(account, now = Date.now()) {
  return !account.customerAvailable || account.enabled && account.mainLineId && !account.mainLineAvailable
    || account.lockedUntil > now || !!account.resetRequiredAt;
}

export function selectPortalAccounts(accounts, { search = "", filter = "all", sort = "name" }, now = Date.now()) {
  const term = search.trim().toLowerCase();
  return accounts.filter(a => [a.customerName, a.customerCode, a.phone].some(value => String(value || "").toLowerCase().includes(term)))
    .filter(a => filter === "all" || filter === "attention" && portalAccountIssue(a, now)
      || filter === "enabled" && a.enabled || filter === "disabled" && !a.enabled
      || filter === "never" && !a.lastLoginAt)
    .sort((a, b) => sort === "recent" ? (b.lastLoginAt || 0) - (a.lastLoginAt || 0)
      || a.customerId.localeCompare(b.customerId)
      : (a.customerName || a.customerCode || a.customerId).localeCompare(b.customerName || b.customerCode || b.customerId));
}
